import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map, filter } from "lodash"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import classnames from "classnames"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import {
  getProjectUUIDAction, getProjectWorksheetLead, getProjectWorksheetLeadUnitDetail, getProjectWorksheetLeadDocDetail,

  getProjectWorksheetLeadPurDetail,
  getProjectWorksheetUnitinfo
} from "../../../store/projects/actions"
import { getProjectLeadCallLog, addProjectLeadCallLog, addProjectLeadEmailLog, getProjectLeadEmailLog, getProjectLeadAct, addProjectleadFollowUp, getProjectLeadFollowUp, addProjectLeadNote, getProjectLeadNote, addActivityProjectFollowUp, getActivityProjectFollowUp } from "../../../store/actions"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr"
import axios from "axios";
import JoditEditor from 'jodit-react';
import MaskedInput from "react-text-mask";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import notes from "../../../assets/images/rsicons/notes.png";
import noteImg from "../../../assets/images/rsicons/notes.png";
import follow from "../../../assets/images/rsicons/follow-up.png";
import phonelog from "../../../assets/images/rsicons/phone-log.png";
import emaillog from "../../../assets/images/rsicons/email-log.png";
import moment from "moment-timezone";
import CurrencyInput from "react-currency-input-field";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import {
  Row,
  Col,
  CardBody,
  Card,

  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  FormGroup,
  Input,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap"
import Moment from 'react-moment';
import { API_URL } from "helpers/app_url";
import { toast, ToastContainer } from "react-toastify";
import RsLink from "components/buttons/rsLink";
import ActionActivity from "components/buttons/actionActivity";
import TimePicker from "components/dropdowns/Timepicker";
import SafeField from "helpers/SafeField";
class projectClient extends Component {
  constructor(props) {
    super(props)
    this.state = {
      worksheetLead: '',
      activeTab1: "1",
      activeTab2: "4",
      activeTab: "1",
      activeTab3: "2",
      showModal: false
    }
    this.toggleViewDocument = this.toggleViewDocument.bind(this);
    this.toggleUnitInformation = this.toggleUnitInformation.bind(this);
    this.toggleSubmittedCanvas = this.toggleSubmittedCanvas.bind(this);
    //this.toggleUploadDocument = this.toggleUploadDocument.bind(this);  
    this.toggleFollowCanvas = this.toggleFollowCanvas.bind(this);
    this.toggleCallLogCanvas = this.toggleCallLogCanvas.bind(this);
    this.toggleEmailLogCanvas = this.toggleEmailLogCanvas.bind(this);
    this.toggleSmsLogCanvas = this.toggleSmsLogCanvas.bind(this);
    this.toggleAddNoteCanvas = this.toggleAddNoteCanvas.bind(this);
    this.toggleMessageCanvas = this.toggleMessageCanvas.bind(this);
    this.toggleAddLeadCanvas = this.toggleAddLeadCanvas.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
     this.handelSubmitMessage = this.handelSubmitMessage.bind(this)
    this.toggle3 = this.toggle3.bind(this);

    this.dt = createRef();
  }
   handelSubmitMessage = (value, { resetForm }) => {
       const payload = {
         messageFromId: parseInt(value.messageFromId),
         messageToId: parseInt(value.messageToId),
         messageFrom: value.messageFrom,
         messageTo: value.messageTo,
         messageText: value.messageText,
         agentId: parseInt(value.agentId),
         isActive: true,
       }
       const obj = JSON.parse(localStorage.getItem("authUser"));
       const token = obj?.resultData?.bearerToken;
       const url = `${API_URL}ProjectCampaignLeadMessage`;
       toast.loading("Please wait...");
       axios
         .post(url, payload, {
           headers: {
             Authorization: `Bearer ${token}`,
             "Content-Type": "application/json",
           },
         })
         .then((response) => {
           if (response.data.success) {
             toast.dismiss();
             toast.success("Saved successfully");
             resetForm();
             this.fetchLeadMessage(value.messageToId);
           } else {
             toast.dismiss();
             toast.error('some issue while sending message');
             console.warn("Submission failed:", response.data);
           }
         })
         .catch((error) => {
           console.error("Error sending message:", error);
   
         });
     }
    fetchLeadMessage(leadId) {
       const { lead } = this.state;
         const obj = JSON.parse(localStorage.getItem("authUser"));
         const token = obj?.resultData?.bearerToken;
         const headers = {
           Authorization: `Bearer ${token}`,
           "Content-Type": "application/json",
         };
     
         const params = {
           LeadId: leadId,
           agentId: localStorage.getItem('userId')
         };
         axios
           .get(`${API_URL}ProjectCampaignLeadMessage/allLead`, { headers, params })
           .then((response) => {
             this.setState({ leadMessages: response.data, loading: false });
           })
           .catch((error) => {
             this.setState({ error: error.message, loading: false });
           });
       }
  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };
  handlePrint = () => {
    const printContents = document.getElementById("print-content").innerHTML;
    const newWindow = window.open("", "", "width=800,height=600");
    newWindow.document.write(`
      <html><head><title>Print</title></head>
      <body>${printContents}</body></html>
    `);
    newWindow.document.close();
    newWindow.print();
  };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll
    }));
  }
  isAllCanavas() {
    this.setState({ worksheetLead: "", isAll: !this.state.isAll });
    this.toggleAllCanavas();
  }
  isAllCanavas = arg => {
    const worksheetLead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      worksheetLead: {
        projectCampaignLeadId: worksheetLead.projectCampaignLeadId,
        campaignProjectGuid: worksheetLead.campaignProjectGuid,
        campaignProjectId: worksheetLead.campaignProjectId,
        email: worksheetLead.email,
        cellPhone: worksheetLead.cellPhone,
        agentName: worksheetLead.name,
        leadId: worksheetLead.leadId
      },
    });
    if(worksheetLead.projectCampaignLeadId > 0 ){
    onGetFollowLead(worksheetLead.projectCampaignLeadId, worksheetLead.campaignProjectGuid);
    onGetNoteLead(worksheetLead.projectCampaignLeadId, worksheetLead.campaignProjectGuid);
    onGetLeadCallLog(worksheetLead.projectCampaignLeadId, worksheetLead.campaignProjectGuid);
    onGetLeadEmailLog(worksheetLead.projectCampaignLeadId, worksheetLead.campaignProjectGuid);
    onGetAllActLead(worksheetLead.projectCampaignLeadId, worksheetLead.campaignProjectGuid)
    }
    this.toggleAllCanavas();
  };
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }

  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }
  docViewToggle() {
    this.setState({ isDocView: !this.state.isDocView });
  }
  unitViewToggle() {
    this.setState({ isUnitView: !this.state.isUnitView });
  }
  uploadDocToggle() {
    this.setState({ isUploadDoc: !this.state.isUploadDoc });
  }
  componentDidMount() {
    const { match: { params }, ongetProjectUUIDAction, onGetProjectWorksheetLead } = this.props;
    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectWorksheetLead(params.projectId, 3);
    }
  }
  toggleViewDocument() {
    this.setState({ worksheetLead: '', isDocView: !this.state.isDocView });
    this.docViewToggle();
  }
  toggleViewDocument = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadDocDetail } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,
      }
    });
    onGetProjectWorksheetLeadDocDetail(worksheetLead.id);
    this.docViewToggle();
  };

  toggleUnitInformation() {
    this.setState({ worksheetLead: '', isUnitView: !this.state.isUnitView });
    this.unitViewToggle();
  }
  toggleUnitInformation = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadUnitDetail } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,
        unitNote: worksheetLead.unitNote,
        unitStatusId: worksheetLead.unitStatusId,
        unitStatusText: worksheetLead.unitStatusText,
        projectLeadWorkSheetId: worksheetLead.projectLeadWorkSheetId

      }
    });
    onGetProjectWorksheetLeadUnitDetail(worksheetLead.id);
    this.unitViewToggle();
  };
  toggleSubmit() {

    this.setState({ isSubmittedData: !this.state.isSubmittedData });

  }
  toggleSubmittedCanvas() {
    this.setState({ worksheetLead: '', isSubmittedData: !this.state.isSubmittedData });
    this.toggleSubmit();
  }
  toggleSubmittedCanvas = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadPurDetail, onGetProjectWorksheetLeadUnitDetail, onGetProjectWorksheetLeadDocDetail, onGetProjectWorksheetUnitinfo } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,
        unitStatusId: worksheetLead.unitStatusId,
        projectCampaignLeadId: worksheetLead.projectCampaignLeadId,
        isLockerRequired: worksheetLead.isLockerRequired,
        isParkingRequired: worksheetLead.isParkingRequired
      }
    });
    //
    onGetProjectWorksheetLeadPurDetail(worksheetLead.id);
    onGetProjectWorksheetLeadUnitDetail(worksheetLead.id);
    onGetProjectWorksheetLeadDocDetail(worksheetLead.id);
    onGetProjectWorksheetUnitinfo(worksheetLead.id)
    this.toggleSubmit();
  };

  removeEmptySheetAllocationList = (data) => {
    return data.filter(item => item.insideSqFt !== '' || item.outsideSqFt !== '');
  }
  // Short Function
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }
  toggleFollow() {
    this.setState(prevState => ({
      isFollow: !prevState.isFollow
    }));

  }
  toggleAddNote() {
    this.setState(prevState => ({
      isAddNote: !prevState.isAddNote
    }));

  }
  toggleCallLog() {
    this.setState(prevState => ({
      isCallLog: !prevState.isCallLog
    }));

  }
  toggleWorkSheet() {
    this.setState({ isWorkSheet: !this.state.isWorkSheet });
  }
  toggleEmailLog() {
    this.setState(prevState => ({
      isEmailLog: !prevState.isEmailLog
    }));

  }
  toggleSmsLog() {
    this.setState(prevState => ({
      isSmsLog: !prevState.isSmsLog
    }));

  }
  toggleCanasEmail() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleEmailCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isRight: !this.state.isRight });
    this.toggleCanasEmail();
  }
  toggleAddNoteCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isFollow: !this.state.isAddNote });
    this.toggleAddNote();
  }
  toggleMessageCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isMessage: !this.state.isMessage });
    //this.toggleAddNote();
  }
  toggleFollowCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isFollow: !this.state.isFollow });
    this.toggleFollow();
  }

  toggleCallLogCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isCallLog: !this.state.isCallLog });
    this.toggleCallLog();
  }

  toggleEmailLogCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isEmailLog: !this.state.isEmailLog });
    this.toggleEmailLog();
  }
  toggleSmsLogCanvas() {
    this.setState({ worksheetLead: "", isEdit: false, isSmsLog: !this.state.isSmsLog });
    this.toggleSmsLog();
  }
  toggleOpenHouse() {
    this.setState(prevState => ({
      isEditOpenHouse: !prevState.isEditOpenHouse
    }));
  }
  toggleOpenHouseCanvas() {
    this.setState({ isEditOpenHouseData: {}, isEditOpenHouse: !this.state.isEditOpenHouse });
    this.toggleOpenHouse();
  }

  toggleOpenHouseCanvas = arg => {
    this.setState({ isEditOpenHouseData: arg });
    // onGetNoteLead(camplead.leadId);
    this.toggleOpenHouse();
  };

  toggleAddNoteCanvas() {
    this.setState({ camplead: "", isEdit: false, isAddNote: !this.state.isAddNote });
    this.toggleAddNote();
  }


  toggleFollowCanvas = arg => {
    const worksheetLead = arg;
    const { onGetFollowLead } = this.props;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.leadId,
      },
      isEditFollow: true,
    });
    onGetFollowLead(worksheetLead.leadId);
    this.toggleFollow();
  };
  toggleAddNoteCanvas = arg => {
    const worksheetLead = arg;
    const { onGetNoteLead } = this.props;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.leadId,
      },
      isEdit: true,
    });
    onGetNoteLead(worksheetLead.leadId);
    this.toggleAddNote();
  };

  toggleCallLogCanvas = arg => {
    const worksheetLead = arg;
    const { onGetLeadCallLog } = this.props;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.leadId,
      },

    });
    onGetLeadCallLog(worksheetLead.leadId);
    this.toggleCallLog();
  };
  toggleEmailLogCanvas = arg => {
    const worksheetLead = arg;
    const { onGetLeadEmailLog } = this.props;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.leadId,
      },
      isEditCall: true,
    });
    onGetLeadEmailLog(worksheetLead.leadId);
    this.toggleEmailLog();
  };
  toggleSmsLogCanvas = arg => {
    const worksheetLead = arg;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.id
      },


    });
    this.toggleSmsLog();
  };
  toggleAddLeadCanvas() {
    this.setState({ isAddLead: !this.state.isAddLead });
    //this.toggleAddLead();
  }
  toggleEmailCanvas = arg => {
    //alert('Hi');
    const worksheetLead = arg;
    const { onGetAllActLead } = this.props;
    this.setState({
      worksheetLead: {
        leadId: worksheetLead.leadId,

      },
      isEdit: true,
    });
    onGetAllActLead(worksheetLead.leadId)
    this.toggleCanasEmail();
  };

  // handelSendMessage = (value, { resetForm }) => {
  //   const payload = {
  //     refId: parseInt(value.refId),
  //     addedDate: new Date(),
  //     message: value.message,
  //     addedBy: parseInt(value.addedBy),
  //     activityParentRefId: parseInt(value.activityParentRefId),
  //     activityParentRefGuid: value.activityParentRefGuid,
  //     activityParentRefTypeId: parseInt(value.activityParentRefTypeId),

  //   }
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   const token = obj?.resultData?.bearerToken;
  //   const url = `${API_URL}ProjectCampaignLeadActivities/LeadLogSendSMS`;
  //   toast.loading("Please wait...");
  //   axios
  //     .post(url, payload, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       if (response.data.success) {
  //         toast.dismiss();
  //         toast.success("Saved successfully");
  //         resetForm();
  //         this.fetchLeadMessage();
  //       } else {
  //         toast.dismiss();
  //         toast.error('some issue while sending message');
  //         console.warn("Submission failed:", response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error sending message:", error);

  //     });
  // }


  // fetchLeadMessage() {
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   const token = obj?.resultData?.bearerToken;
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": "application/json",
  //   };

  //   const params = {
  //     LeadId: this.props.match.params.id,
  //   };
  //   axios
  //     .get(`${API_URL}LeadMessage/allLead`, { headers, params })
  //     .then((response) => {
  //       this.setState({ leadMessages: response.data, loading: false });
  //     })
  //     .catch((error) => {
  //       this.setState({ error: error.message, loading: false });
  //     });
  // }
  handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
  render() {
    const { projectData, worksheetLeads, onGetProjectWorksheetLead, worksheetPurData, worksheetUnitData, worksheetDocData, unitdata, onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog } = this.props;
    const { notes, followups, calllogs, emaillogs, activities, leadFollows, isResponsive, onGetAllActLead  } = this.props;
    const { isEdit, isEditFollow, isEditCall, lead, leadMessages } = this.state;
    const worksheetLead = this.state.worksheetLead;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { projectId } = this.props.match.params;
    const tabs = [
      {
        id: "project-leads",
        label: "Project Leads",
        link: `/pre-construction/campaign/current-prospects/${projectId}`
      },
      {
        id: "worksheets",
        label: "Worksheets",
        link: `/pre-construction/campaign/srr-filled/${projectId}`
      },
      {
        id: "clients",
        label: "Clients",
        link: `/pre-construction/campaign/client/${projectId}`
      }
    ];
    const currentPath = this.props.location.pathname;
    return (
      <React.Fragment>
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <ToastContainer autoClose={2000} />
            <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Activity")} />
                  </Col>
                  <Col sm="4">
                    <h2 className="">{this.props.t(projectData.projectName)}</h2>
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    {isResponsive ? (
                      <Card>
                        <CardBody>
                          <h6>Select Menu</h6>
                          <select
                            className="form-select mb-3"
                            value={currentPath}
                            onChange={this.handleSelectChange}
                          >
                            {tabs.map((tab) => (
                              <option key={tab.id} value={tab.link}>
                                {tab.label}
                              </option>
                            ))}
                          </select>
                        </CardBody>
                      </Card>
                    ) : (
                      <Nav tabs className="projectTab projectNav">

                        <NavItem>
                          <Link className="nav-link " to={"/pre-construction/campaign/current-prospects/" + this.props.match.params.projectId}

                          >
                            <span className="d-none d-sm-block">{this.props.t("Office Leads")}</span>

                          </Link>
                        </NavItem>
                          <NavItem>

                        <Link className="nav-link" to={"/pre-construction/campaign/transferred/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">Transferred Lead</span>

                        </Link>
                      </NavItem>
                        <NavItem>
                          <Link className="nav-link " to={"/pre-construction/campaign/srr-filled/" + this.props.match.params.projectId}

                          >
                            <span className="d-none d-sm-block">{this.props.t("Worksheets")}</span>

                          </Link>
                        </NavItem>

                        <NavItem>
                          <Link className="nav-link active" to={"/pre-construction/campaign/client/" + this.props.match.params.projectId}

                          >
                            <span className="d-none d-sm-block">{this.props.t("Clients")}</span>

                          </Link>
                        </NavItem>

                      </Nav>
                    )}


                  </Col>

                </Row>
                <Row>

                  <Col lg="12">

                    <Card>
                      <CardBody>
                        {isResponsive ? (
                          <DataTable
                            value={worksheetLeads}
                            paginator
                            rows={10}
                            stripedRows
                            responsiveLayout="scroll"
                            expandedRows={this.state.expandedRows}
                            onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                            rowExpansionTemplate={(rowData) => (
                              <table className="table table-sm mb-0 bg-light">
                                <tbody>
                                  <tr>
                                    <th>Date</th>
                                    <td>
                                      {rowData.filledDate ? (
                                        <Moment format="D MMM YY">{rowData.filledDate}</Moment>
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Email</th>
                                    <td>{rowData.email || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>Phone</th>
                                    <td>{rowData.cellPhone || "N/A"}</td>
                                  </tr>
                                  <tr>
                                    <th>Source</th>
                                    <td>
                                      {rowData.leadSourceId
                                        ? localization["LeadSource_" + rowData.leadSourceId]
                                        : "Manual"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Action</th>
                                    <td>
                                      <ActionActivity onClick={() => this.isAllCanavas(rowData)} />{" "}
                                      <button
                                        className="btn btn-action"
                                        onClick={() => this.toggleSubmittedCanvas(rowData)}
                                      >
                                        Manage
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            )}
                          >
                            <Column expander style={{ width: "3rem" }} />
                             <Column
                                                    header="#"
                                                    body={(rowData, options) => options.rowIndex + 1}
                                                    style={{ width: '60px' }}
                                                  />
                            <Column
                              field="name"
                              header="Name"
                              body={(rowData) => (
                                <div>
                                  <strong>{rowData.name}</strong>
                                  <div className="text-muted small">{rowData.email}</div>
                                </div>
                              )}
                            />
                            <Column
                              header="Date"
                              body={(rowData) =>
                                rowData.filledDate ? (
                                  <Moment format="D MMM YY">{rowData.filledDate}</Moment>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            value={worksheetLeads}
                            paginator
                            rows={10}
                            stripedRows
                            responsiveLayout="scroll"
                            ref={this.dt}
                          >
                            {/* Name column with icon */}
                             <Column
                                                    header="#"
                                                    body={(rowData, options) => options.rowIndex + 1}
                                                    style={{ width: '60px' }}
                                                  />
                            <Column
                              header={this.props.t("Name")}

                              field="name"
                              filter
                              filterPlaceholder=""
                              showFilterMatchModes={false}
                              showFilterOperator={false}
                              showAddButton={false}
                              showClearButton={false}
                            />

                            {/* Date column */}
                            <Column
                              header={this.props.t("Date")}
                              body={(rowData) =>
                                rowData.filledDate ? <Moment format="D MMM YY">{rowData.filledDate}</Moment> : ''
                              }

                            />

                            {/* Email column */}
                            <Column field="email" header={this.props.t("Email")}
                              filter
                              filterPlaceholder=""
                              showFilterMatchModes={false}
                              showFilterOperator={false}
                              showAddButton={false}
                              showClearButton={false}
                            />

                            {/* Source column */}
                            <Column
                              field="leadSourceId"
                              header={this.props.t("Source")}
                              body={(rowData) => rowData.leadSourceId ? localization["LeadSource_" + rowData.leadSourceId] : 'Manual'}

                              filter
                              filterPlaceholder=""
                              showFilterMatchModes={false}
                              showFilterOperator={false}
                              showAddButton={false}
                              showClearButton={false}
                            />

                            {/* Phone column */}
                            <Column field="cellPhone" header={this.props.t("Phone")}
                              filter
                              filterPlaceholder=""
                              showFilterMatchModes={false}
                              showFilterOperator={false}
                              showAddButton={false}
                              showClearButton={false}
                            />

                            {/* Action column */}
                            <Column
                              headerClassName="action-header"
                              header={
                                <div className="justify-content-end">
                                  <RsLink
                                    onClick={() => this.dt.current.reset()}
                                    iconClass="bx bx-reset"
                                    className="btn-light"
                                  >
                                    Reset all filters
                                  </RsLink>
                                </div>
                              }
                              body={(rowData) => (
                                <>
                                  <ActionActivity onClick={() => this.isAllCanavas(rowData)} />

                                  <button
                                    className="btn btn-action"
                                    onClick={() => this.toggleSubmittedCanvas(rowData)}
                                  >
                                    Manage
                                  </button>
                                </>
                              )}
                            />
                          </DataTable>
                        )}








                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>

                </Row>
              </Col>
            </Row>
          </Container>
          <Offcanvas
            isOpen={this.state.isAll}
            direction="end"
            toggle={this.isAllCanavas}
            style={{ width: 800 }}
            s
          >
            <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
              Activities
            </OffcanvasHeader>
            <OffcanvasBody>
              <Nav pills className="navtab-bg nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "2",
                    })}
                    onClick={() => {
                      this.toggle3("2");
                      onGetAllActLead(worksheetLead?.leadId, projectId)
                    }}
                  >
                    All Activities
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "1",
                    })}
                    onClick={() => {
                      this.toggle3("1");
                    }}
                  >
                    Follow Up
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "3",
                    })}
                    onClick={() => {
                      this.toggle3("3");
                      this.fetchLeadMessage(worksheetLead?.leadId);
                    }}
                  >
                    Message
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "4",
                    })}
                    onClick={() => {
                      this.toggle3("4");
                    }}
                  >
                    Add Notes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "5",
                    })}
                    onClick={() => {
                      this.toggle3("5");
                    }}
                  >
                    Call Log
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "6",
                    })}
                    onClick={() => {
                      this.toggle3("6");
                    }}
                  >
                    Email Log
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={this.state.activeTab3}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        agentId: parseInt(localStorage.getItem("userId")),
                        title: "Call-Follow Up",
                        contactname: worksheetLead.agentName,
                        contactphone: worksheetLead.cellPhone,
                        contactemail: worksheetLead.email,
                        //addedDate: new Date(),
                        activityStartDate: new Date(),
                        startTime: "",
                        endTime: "",
                        activityStatus: 1,
                        activityType: 3,
                        activityRefId: worksheetLead.leadId,
                        activityDescription: (this.state && this.state.activityDescription) || "",
                        activityLocationType: 3,
                        activityLocation: "",
                        activityParentRefGuid: worksheetLead.campaignProjectGuid,
                        activityParentRefTypeId: worksheetLead.campaignProjectId,
                        isActive: true,
                        category: 3
                      }}
                      validationSchema={Yup.object().shape({
                        activityDescription: Yup.string().required("This is Required"),
                        startTime: Yup.string().when('activityType', {
                          is: 1,
                          then: Yup.string().required("Start time is required"),
                          otherwise: Yup.string().nullable()
                        }),

                        endTime: Yup.string().when('activityType', {
                          is: 1,
                          then: Yup.string().required("End time is required"),
                          otherwise: Yup.string().nullable()
                        })
                      })}
                      onSubmit={(values, { resetForm }) => {
                        const formattedValues = {
                          ...values,
                          activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

                        };
                        onAddLeadFollowUp(formattedValues);
                        onGetAllActLead(lead.leadId, lead?.projectGuid)

                      }}

                    >
                      {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                        <Form
                          className="needs-validation"
                        >

                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">

                                <div className="clearfix"></div>
                                <div className="btn-group" role="group">
                                  <SafeField type="radio" className="btn-check"
                                    name="activityType" id="btnradio4"
                                    value={3}
                                    checked={values.activityType === 3}
                                    onChange={() => {
                                      setFieldValue("activityType", 3)
                                      setFieldValue("title", "Call Log")
                                    }}
                                    autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                                  <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={10}
                                    checked={values.activityType === 10}

                                    onChange={() => {
                                      setFieldValue("activityType", 10)
                                      setFieldValue("title", "Message")
                                    }}

                                    autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>

                                  <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                    value={4}
                                    checked={values.activityType === 4}

                                    onChange={() => {
                                      setFieldValue("activityType", 4)
                                      setFieldValue("title", "Email")
                                    }}
                                    autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>

                                  <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                    checked={values.activityType === 1}

                                    onChange={() => {
                                      setFieldValue("activityType", 1)
                                      setFieldValue("title", "Meeting")
                                    }}

                                    autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>

                                   <SafeField type="radio" className="btn-check" name="activityType" id="btnradio8" value={2}
                                    checked={values.activityType === 2}

                                    onChange={() => {
                                      setFieldValue("activityType", 2)
                                      setFieldValue("title", "Task")
                                    }}

                                    autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio8">Task</label>


                                </div>
                                <ErrorMessage
                                  name="activityType"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="activityDescription">
                                  {this.props.t("Description *")}
                                </Label>
                                <SafeField
                                  name="activityDescription"
                                  onChange={handleChange}
                                  as="textarea"
                                  className={
                                    "form-control" +
                                    (errors.activityDescription && touched.activityDescription
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityDescription"
                                />
                                <ErrorMessage
                                  name="activityDescription"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            <Col md="12">
                              <FormGroup className="mb15">

                                <Label htmlFor="activityStartDate">
                                  Date
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.activityStartDate && touched.activityStartDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.activityStartDate}
                                  onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
                                <ErrorMessage
                                  name="logDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                          </Row>
                          {values.activityType === 1 && (
                            <>
                              <Row>
                                <Col md="6">
                                  <TimePicker
                                    name="startTime"
                                    label="Start Time *"
                                    value={values.startTime}
                                    onChange={(val) => setFieldValue("startTime", val)}
                                    onBlur={() => setFieldTouched("startTime", true)}
                                    minTime={null}
                                    error={errors.startTime}
                                    touched={touched.startTime}
                                  />

                                </Col>
                                <Col md="6">
                                  <TimePicker
                                    name="endTime"
                                    label="End Time *"
                                    value={values.endTime}
                                    onChange={(val) => setFieldValue("endTime", val)}
                                    onBlur={() => setFieldTouched("endTime", true)}
                                    minTime={values.startTime}
                                    disabled={!values.startTime}
                                    error={errors.endTime}
                                    touched={touched.endTime}
                                  />

                                </Col>
                                <Col md="12">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="notes">
                                      {this.props.t("Location")}
                                    </Label>
                                    <div className="clearfix"></div>
                                    <div className="btn-group" role="group">

                                      <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio91" value={3}
                                        onChange={() => setFieldValue("activityLocationType", 3)}
                                        autoComplete="off" />
                                      <label className="btn btn-outline-secondary" htmlFor="btnradio91">In-person</label>
                                      <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio101" value={1}
                                        onChange={() => setFieldValue("activityLocationType", 1)}
                                        autoComplete="off" />
                                      <label className="btn btn-outline-secondary" htmlFor="btnradio101">Online</label>
                                    </div>

                                  </FormGroup>
                                </Col>

                                <Col md="12">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="addressLine1">
                                      {this.props.t("Location")}
                                    </Label>
                                    {values.activityLocationType === 3 ? (
                                      <PlacesAutocomplete
                                        value={values.activityLocation}
                                        onChange={(value) => setFieldValue('activityLocation', value)}
                                        onSelect={(value) => this.handleFollowPlaceSelected(value, setFieldValue)}
                                      >
                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                          <div>
                                            <input
                                              {...getInputProps({
                                                placeholder: 'Enter Address...',
                                                className: 'form-control',

                                              })}
                                            />
                                            <div className="">
                                              {loading ? <div>Loading...</div> : null}

                                              {suggestions.map((suggestion, i) => {
                                                const className = suggestion.active
                                                  ? 'suggestion-item--active'
                                                  : 'suggestion-item';
                                                const style = suggestion.active
                                                  ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                  : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                return (
                                                  <div
                                                    key={i}
                                                    {...getSuggestionItemProps(suggestion, {
                                                      style,
                                                    })}
                                                  >
                                                    {suggestion.description}
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </PlacesAutocomplete>
                                    ) : (
                                      <SafeField
                                        name="activityLocation"
                                        onChange={handleChange}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.activityLocation && touched.activityLocation
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="activityLocation"

                                      />
                                    )}
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                          )}
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                        </Form>
                      )}
                    </Formik>

                    <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                    <ul className="verti-timeline list-unstyled">

                      {map(leadFollows, (follLog, follLogkey) => (

                        <li className="event-list eventlist" key={"_note_" + follLogkey}>
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle font-size-18" />
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>


                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14"></h5>
                            </div>
                          </div>
                          <div className="exNote">{follLog.activityDetails}</div>
                        </li>
                      ))}

                    </ul>


                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="tabContent">
                    <ul className="verti-timeline list-unstyled">
                      {map(
                        activities,
                        (allactivity, allactkey) => (
                          <li
                            className="event-list eventlist"
                            key={"_allact_" + allactkey}
                          >
                            <div className="event-timeline-dot">
                              {(() => {
                                if (
                                  allactivity.activitySubType ==
                                  8 ||
                                  allactivity.activitySubType ==
                                  9 ||
                                  allactivity.activitySubType ==
                                  7
                                ) {
                                  return (
                                    <>
                                      <img src={emaillog} />
                                    </>
                                  );
                                } else if (
                                  allactivity.activitySubType ==
                                  3 ||
                                  allactivity.activitySubType ==
                                  4 ||
                                  allactivity.activitySubType ==
                                  5
                                ) {
                                  return (
                                    <>
                                      <img src={phonelog} />
                                    </>
                                  );
                                } else if (
                                  allactivity.activitySubType ==
                                  10
                                ) {
                                  return (
                                    <>
                                      <img src={follow} />
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <img src={noteImg} />
                                    </>
                                  );
                                }
                              })()}
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">
                                    {allactivity.addedDate}
                                  </Moment>
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">
                                  {
                                    localization[
                                    "ActivitySubType_" +
                                    allactivity.activityType +
                                    "_" +
                                    allactivity.activitySubType
                                    ]
                                  }
                                </h5>
                              </div>
                            </div>
                            <div className="exNote">
                              {allactivity.activityRemarks}
                            </div>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </TabPane>

                <TabPane tabId="3">
                   <div className="tabContent">
                                                       <Formik
                                                         enableReinitialize={true}
                                                         initialValues={{
                                     
                                                         
                                                           messageFromId:localStorage.getItem("userId"),
                                                           messageToId:worksheetLead?.leadId,
                                                           messageFrom:'Realtor',
                                                           messageTo:'lead',
                                                           agentId: localStorage.getItem('userId'),
                                                           messageText: "",
                                     
                                     
                                     
                                                         }}
                                                         validationSchema={Yup.object().shape({
                                                           messageText: Yup.string().required("This is Required")
                                                         })}
                                     
                                                         onSubmit={this.handelSubmitMessage}
                                                       >
                                                         {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                           <Form
                                                             className="needs-validation"
                                                           >
                                     
                                                             <Row>
                                                               <Col md="12">
                                                                 <FormGroup className="mb-3">
                                                                   <Label htmlFor="messageText">
                                                                     {this.props.t("Send Message *")}
                                                                   </Label>
                                                                   <SafeField
                                                                     name="messageText"
                                                                     onChange={handleChange}
                                                                     as="textarea"
                                                                     className={
                                                                       "form-control" +
                                                                       (errors.messageText && touched.messageText
                                                                         ? " is-invalid"
                                                                         : "")
                                                                     }
                                                                     id="messageText"
                                                                   />
                                                                   <ErrorMessage
                                                                     name="messageText"
                                                                     component="div"
                                                                     className="invalid-feedback"
                                                                   />
                                                                 </FormGroup>
                                                               </Col>
                                                             </Row>
                                                             <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>
                                     
                                     
                                                           </Form>
                                                         )}
                                                       </Formik>
                                                      
                                     
                                     
                                                           {leadMessages && leadMessages.length > 0 ? (
                                                                                                                       <>
                                                         <div className="mb-5 h4 card-title mt-20">Message History</div>
                                                         <ul className="verti-timeline list-unstyled">
                                     
                                                           {map(leadMessages, (noteLog, notekey) => (
                                     
                                                             <li className="event-list eventlist" key={"_note_" + notekey}>
                                                               <div className="event-timeline-dot">
                                                                 <i className="bx bx-right-arrow-circle font-size-18" />
                                                               </div>
                                                               <div className="d-flex">
                                                                 <div className="flex-shrink-0 me-3">
                                                                   <h5 className="font-size-14">
                                                                     <Moment format="D MMM YY">{noteLog.createdDate}</Moment>
                                     
                                     
                                                                   </h5>
                                                                 </div>
                                                                 <div className="flex-grow-1">
                                                                   <h5 className="font-size-14"></h5>
                                                                 </div>
                                                               </div>
                                                               <div className="exNote">{noteLog.messageText}</div>
                                                             </li>
                                                           ))}
                                     
                                                         </ul>
                                                         </>
                                                   ) : null }
                                     
                                                     </div>
                </TabPane>
                <TabPane tabId="4">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{

                        refId: worksheetLead.projectCampaignLeadId,
                        remarks: (this.state && this.state.remarks) || "",
                        addedDate: new Date(),
                        addedBy: parseInt(localStorage.getItem('userId')),
                        activityParentRefId: worksheetLead.projectCampaignLeadId,
                        activityParentRefGuid: worksheetLead.campaignProjectGuid

                      }}
                      validationSchema={Yup.object().shape({
                        remarks: Yup.string().required("This is Required")
                      })}

                      onSubmit={values => {
                        onAddLeadNote(values)
                        //this.toggleAllCanavas();
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >

                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="remarks">
                                  {this.props.t("Add Note *")}
                                </Label>
                                <textarea
                                  name="remarks"
                                  onChange={handleChange}
                                  type="textarea"
                                  className={
                                    "form-control" +
                                    (errors.remarks && touched.remarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="remarks"
                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                        </Form>
                      )}
                    </Formik>
                    <div className="mb-5 h4 card-title mt-20">Notes History</div>
                    <ul className="verti-timeline list-unstyled">

                      {map(notes, (noteLog, notekey) => (

                        <li className="event-list eventlist" key={"_note_" + notekey}>
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle font-size-18" />
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14"></h5>
                            </div>
                          </div>
                          <div className="exNote">{noteLog.activityRemarks}</div>
                        </li>
                      ))}

                    </ul>
                  </div>
                </TabPane>
                <TabPane tabId="5">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        actionType: '',
                        refId: worksheetLead.leadId,
                        addedDate: new Date(),
                        remarks: '',
                        addedBy: localStorage.getItem('userId'),
                        activityParentRefId: worksheetLead.leadId,
                        activityParentRefGuid: worksheetLead.campaignProjectGuid
                      }}
                      validationSchema={Yup.object().shape({
                        actionType: Yup.string().required(
                          "Please Select Action"
                        ),
                        remarks: Yup.string().required(
                          "Enter Note"
                        ),
                      })}

                      onSubmit={values => {

                        onAddCallLog(values)
                        //this.toggleAllCanavas();
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >

                          <Row className="mt20 mb20">



                            <Col lg="12">
                              <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType1" value="No Answer"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }} />
                                  No Answer
                                </label>
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }}
                                  />
                                  Left Voicemail
                                </label>
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }}
                                  />
                                  Bad Number
                                </label>

                              </div>
                              <ErrorMessage
                                name="actionType"
                                component="div"
                                className="invalid-feedback"
                              />

                            </Col>

                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="addedDate">
                                  Log Date
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.addedDate && touched.addedDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.addedDate}
                                  onChange={(value) => setFieldValue('addedDate', value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
                                <ErrorMessage
                                  name="addedDate"
                                  component="div"
                                  className="invalid-feedback"
                                />

                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="remarks">
                                  Add Message
                                </Label>
                                <SafeField
                                  name="remarks"

                                  as="textarea"

                                  className="form-control"
                                  value={values.remarks}
                                  onChange={(e) => setFieldValue("remarks", e.target.value)}
                                  id="remarks"

                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                        </Form>
                      )}
                    </Formik>
                    <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                    <ul className="verti-timeline list-unstyled">

                      {map(calllogs, (callLog, callkey) => (

                        <li className="event-list eventlist" key={"_call_" + callkey}>
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle font-size-18" />
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                            </div>
                          </div>
                          <div className="exNote">{callLog.activityRemarks}</div>
                        </li>
                      ))}

                    </ul>
                  </div>
                </TabPane>
                <TabPane tabId="6">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        actionType: '',
                        refId: worksheetLead.projectCampaignLeadId,
                        addedDate: new Date(),
                        remarks: '',
                        addedBy: localStorage.getItem('userId'),
                        activityParentRefId: worksheetLead.projectCampaignLeadId,
                        activityParentRefGuid: worksheetLead.campaignProjectGuid

                      }}
                      validationSchema={Yup.object().shape({
                        actionType: Yup.string().required(
                          "Please Select Action"
                        )
                      })}

                      onSubmit={values => {
                        onAddEmailLog(values)
                        //this.toggleAllCanavas();
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >

                          <Row className="mt20 mb20">



                            <Col lg="12">
                              <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }}
                                  />
                                  Email Sent
                                </label>
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType2" value="Email Received"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }}
                                  />
                                  Email Received
                                </label>
                                <label>
                                  <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced"
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue("remarks", e.target.value);
                                    }}
                                  />
                                  Email Bounced
                                </label>

                              </div>
                              <ErrorMessage
                                name="actionType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>

                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="addedDate">
                                  Log Date
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.addedDate && touched.addedDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.addedDate}
                                  onChange={(value) => setFieldValue('addedDate', value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
                                <ErrorMessage
                                  name="addedDate"
                                  component="div"
                                  className="invalid-feedback"
                                />

                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="remarks">
                                  Add Message
                                </Label>
                                <SafeField
                                  name="remarks"
                                  onChange={handleChange}
                                  as="textarea"

                                  className="form-control"

                                  id="remarks"

                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                        </Form>
                      )}
                    </Formik>
                    <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                    <ul className="verti-timeline list-unstyled">

                      {map(emaillogs, (emailLog, emailkey) => (

                        <li className="event-list eventlist" key={"_email_" + emailkey}>
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle font-size-18" />
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                            </div>
                          </div>
                          <div className="exNote">{emailLog.activityRemarks}</div>
                        </li>
                      ))}

                    </ul>
                  </div>
                </TabPane>
              </TabContent>



            </OffcanvasBody>
          </Offcanvas>
          <Offcanvas
            isOpen={this.state.isSubmittedData}
            direction="end"
            toggle={this.toggleSubmittedCanvas}
            style={{ width: 600 }}

          >
            <OffcanvasHeader className="submittedWorksheet" toggle={this.toggleSubmittedCanvas}>
              Submitted Worksheet <span className="float-end"><Link onClick={this.toggleModal}><i className=" bx bx-printer"></i></Link></span>
            </OffcanvasHeader>
            <OffcanvasBody>
              <Nav pills className="navtab-bg nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "1",
                    })}
                    onClick={() => {
                      this.toggle1("1");
                    }}
                  >
                    Applicant Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "2",
                    })}
                    onClick={() => {
                      this.toggle1("2");
                    }}
                  >
                    Unit Choices
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "4",
                    })}
                    onClick={() => {
                      this.toggle1("4");
                    }}
                  >
                    Unit Status
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab1 === "3",
                    })}
                    onClick={() => {
                      this.toggle1("3");
                    }}
                  >
                    Documents
                  </NavLink>
                </NavItem>

              </Nav>
              <TabContent
                activeTab={this.state.activeTab1}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <div className="tabContent">
                    {map(worksheetPurData, (purData, purkey) => (
                      <>
                        <h5>{purkey + 1 === 1 ? "Principal Applicant" : "Secondary Applicant"}</h5>
                        <div className="table-responsive">
                          <Table className="table table-sm m-0">

                            <tbody>
                              <tr>
                                <th scope="row">Name</th>
                                <td>{purData.firstName + " " + purData.lastName}</td>

                              </tr>
                              <tr>
                                <th scope="row">Address</th>
                                <td>{purData.address}</td>
                              </tr>
                              <tr>
                                <th scope="row">City</th>
                                <td>{purData.city}</td>

                              </tr>
                              <tr>
                                <th scope="row">Province</th>
                                <td>{purData.province}</td>

                              </tr>
                              <tr>
                                <th scope="row">Phone</th>
                                <td>{purData.homePhone}</td>

                              </tr>
                              <tr>
                                <th scope="row">Cell</th>
                                <td>{purData.cellPhone}</td>
                              </tr>
                              <tr>
                                <th scope="row">Email</th>
                                <td>{purData.email}</td>

                              </tr>
                              <tr>
                                <th scope="row">Birth Date</th>
                                <td>{purData.birthDate ? <Moment format="D MMM YY">{purData.birthDate}</Moment> : ''}</td>
                              </tr>
                              <tr>
                                <th scope="row">Drivers License</th>
                                <td>{purData.driversLicense}</td>

                              </tr>
                              <tr>
                                <th scope="row">Occupation</th>
                                <td>{purData.occupation}</td>
                              </tr>

                            </tbody>
                          </Table>
                        </div>
                        <p>{" "}</p>
                      </>
                    ))}
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="tabContent">
                    <div className="table-responsive">
                      <Table className="table table-sm m-0">

                        <tbody>
                          <tr>
                            <th scope="row">Parking</th>
                            <td>
                              {worksheetLead.isLockerRequired ? 'Yes' : 'No'}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">Locker</th>
                            <td>
                              {worksheetLead.isParkingRequired ? 'Yes' : 'No'}
                            </td>
                          </tr>
                          {map(worksheetUnitData, (unitData, unitkey) => (
                            <>
                              <tr>
                                <th scope="row">Choice {unitkey + 1}</th>
                                <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>


                              </tr>
                              <tr>
                                <td colSpan="2">Notes: {unitData.optionNotes}</td>
                              </tr>
                            </>
                          ))}


                        </tbody>
                      </Table>
                    </div>
                  </div>
                </TabPane>

                <TabPane tabId="3">
                  <div className="tabContent">
                    <div className="table-responsive">


                      <h5>Purchaser</h5>
                      <Table className="table table-sm m-0">

                        <tbody>
                          {map(worksheetDocData, (docData, dockey) => (
                            <tr>
                              <th scope="row">{dockey + 1 === 1 ? "Principal Applicant" : "Secondary Applicant"}</th>
                              <td>{docData.documentTitle}</td>
                              <td><a target="_blank" rel="noreferrer" href={docData.documentURL}>View</a></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <p>{" "}</p>



                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="4">
                  <TabPane tabId="4">
                    <div className="tabContent">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          updateViaEmail: unitdata?.updateViaEmail ? true : false,
                          depositPaymentReceived: unitdata?.depositPaymentReceived ? true : false,
                          paymentInfo: unitdata?.paymentInfo ? unitdata.paymentInfo : '',
                          emailContent: unitdata?.emailContent ? unitdata.emailContent : '',
                          id: worksheetLead.id,
                          projectLeadWorkSheetId: worksheetLead.id,
                          unitStatusId: (unitdata?.unitStatusId) ? unitdata.unitStatusId : 1,
                          unitStatusText: (unitdata?.unitStatusText) ? unitdata.unitStatusText : 'Waiting for allocations',
                          unitNote: (unitdata?.unitNote) ? unitdata.unitNote : '',
                          allocationBy: parseInt(localStorage.getItem('userId')),
                          selectedOptionId: 0,
                          createProjectLeadWorkSheetAllocationList: map(
                            filter(worksheetUnitData, unit => unit.isAllocated === true),
                            item => ({
                              projectLeadWorkSheetId: worksheetLead.id,
                              selectedOptionId: item?.isAllocated ? item?.id : null,
                              selectedOptionText: item?.optionNumber
                                ? `${item.optionNumber}/${item.optionType}`
                                : "",
                              unitCost: item?.unitCost || "",
                              insideSqFt: item?.insideSqFt || "",
                              outsideSqFt: item?.outsideSqFt || "",
                            })) || []

                        }}
                        validationSchema={Yup.object().shape({
                          // createProjectLeadWorkSheetAllocationList: Yup.array().of(
                          //   Yup.object().shape({
                          //     selectedOptionId: Yup.string().required("Option ID is required"),
                          //     insideSqFt: Yup.number()
                          //       .typeError("Must be a number")
                          //       .when("selectedOptionId", {
                          //         is: (val) => !!val,
                          //         then: Yup.number().required("Inside sq. ft. is required"),
                          //       }),
                          //     outsideSqFt: Yup.number()
                          //       .typeError("Must be a number")
                          //       .when("selectedOptionId", {
                          //         is: (val) => !!val,
                          //         then: Yup.number().required("Outside sq. ft. is required"),
                          //       }),
                          //     unitCost: Yup.number()
                          //       .typeError("Must be a number")
                          //       .when("selectedOptionId", {
                          //         is: (val) => !!val,
                          //         then: Yup.number().required("Cost is required"),
                          //       }),
                          //   })
                          // ),
                        })}

                        onSubmit={(values) => {
                          const filteredList = this.removeEmptySheetAllocationList(values.createProjectLeadWorkSheetAllocationList);
                          const convertedList = filteredList.map(item => ({
                            ...item,
                            unitCost: parseInt(item.unitCost, 10) || 0,
                            insideSqFt: parseInt(item.insideSqFt, 10) || 0,
                            outsideSqFt: parseInt(item.outsideSqFt, 10) || 0,
                          }));

                          const allocationData = {
                            ...values,
                            createProjectLeadWorkSheetAllocationList: convertedList,
                          };
                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj.resultData.bearerToken;
                          const str = 'Bearer ' + token;
                          const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': str
                          };

                          toast.loading("Please wait...");
                          axios.post('https://rscoreapi.azurewebsites.net/api/ProjectLeadWorkSheet/AddProjectLeadWorkSheetAllocation', allocationData, { headers })
                            .then(response => {
                              toast.dismiss();
                              if (response.data.success) {
                                toast.success("Saved successfully");
                                onGetProjectWorksheetLead(this.props.match.params.projectId, 3);
                                this.toggleSubmit();
                              } else {
                                toast.warn(response.validationErrors[0]);
                              }
                            })
                            .catch(error => {
                              toast.dismiss();
                              console.error('Error:', error);
                            });
                        }}
                      >
                        {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>



                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline3"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="3"
                                    checked={values.unitStatusId === 3}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 3);
                                      setFieldValue('unitStatusText', 'Unit Allocated');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline3"
                                  >
                                    <span className="">Unit Allocated</span>
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">


                                  <Input
                                    type="radio"
                                    id="customRadioInline4"
                                    name="unitStatusId"
                                    className="form-check-input mt-2"
                                    value="4"
                                    checked={values.unitStatusId === 4}
                                    onChange={(e) => {
                                      setFieldValue('unitStatusId', 4);
                                      setFieldValue('unitStatusText', 'Withdrawn from client');
                                    }}
                                  />
                                  <Label
                                    className="form-check-label ms-4"
                                    htmlFor="customRadioInline4"
                                  >
                                    Withdrawn from client
                                  </Label>
                                </FormGroup>
                              </Col>
                            </Row>
                            {values.unitStatusId !== 1 && (
                              <>
                                <hr></hr>
                                {values.unitStatusId !== 2 && values.unitStatusId !== 4 && (
                                  <>
                                    <div id="Selchoice">
                                      <FieldArray name="createProjectLeadWorkSheetAllocationList">
                                        {({ insert, remove, push }) => (
                                          <>
                                            {map(
                                              filter(worksheetUnitData, unitData => unitData.isAllocated === true),
                                              (unitData, unitkey) => (
                                                <Row key={unitkey}>
                                                  <Col md="12">
                                                    <div className="form-check mb-3">
                                                      <SafeField
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                        //value={unitData.id}
                                                        id={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                        onChange={(e) => {
                                                          const isChecked = e.target.checked;
                                                          const newValue = isChecked ? unitData.id : null;
                                                          const optionText = isChecked ? `${unitData.optionNumber}/${unitData.optionType}` : '';

                                                          setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`, newValue);
                                                          setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionText`, optionText);
                                                        }}
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        id={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                      >
                                                        {unitData.optionNumber}/{unitData.optionType}
                                                      </label>
                                                    </div>

                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}>
                                                        {this.props.t("Inside sq. ft.")}
                                                      </Label>
                                                      <SafeField
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                        type="text"
                                                        className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt &&
                                                          touched.createProjectLeadWorkSheetAllocationList &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt
                                                          ? " is-invalid"
                                                          : ""
                                                          }`}
                                                      />
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}>
                                                        {this.props.t("Outside sq.ft")}
                                                      </Label>
                                                      <SafeField
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          errors.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt &&
                                                          touched.createProjectLeadWorkSheetAllocationList &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                          touched.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt
                                                          ? " is-invalid"
                                                          : ""
                                                          }`}
                                                      />
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}>
                                                        Cost ({projectData.projectCurrencyCode})
                                                      </Label>
                                                      <CurrencyInput
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                        value={values.createProjectLeadWorkSheetAllocationList?.[unitkey]?.unitCost}
                                                        className="form-control"
                                                        onValueChange={(value) => setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`, value)}
                                                        prefix={projectData?.projectCurrencyCode}
                                                        decimalsLimit={2}


                                                      />
                                                      {/* <SafeField
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            errors.createProjectLeadWorkSheetAllocationList[unitkey].unitCost &&
                                                            touched.createProjectLeadWorkSheetAllocationList &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                            touched.createProjectLeadWorkSheetAllocationList[unitkey].unitCost
                                                            ? " is-invalid"
                                                            : ""
                                                          }`}
                                                      /> */}
                                                      <ErrorMessage
                                                        name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                </Row>


                                              ))}
                                          </>
                                        )}
                                      </FieldArray>
                                    </div>
                                    <Row>
                                      <Col sm="12">
                                        <div className="form-check mb-3">
                                          <SafeField
                                            className="form-check-input"
                                            type="checkbox"
                                            name="depositPaymentReceived"
                                            id="depositPaymentReceived"
                                          />
                                          {" "} <label htmlFor="depositPaymentReceived" className="form-check-label">Deposit payment received</label>
                                        </div>
                                      </Col>
                                      {values.depositPaymentReceived && (
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="paymentInfo">
                                              {this.props.t("Payment info")}
                                            </Label>
                                            <SafeField
                                              name="paymentInfo"
                                              onChange={handleChange}
                                              as="textarea"
                                              className={
                                                "form-control" +
                                                (errors.paymentInfo && touched.paymentInfo
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              id="paymentInfo"
                                            />
                                            <ErrorMessage
                                              name="paymentInfo"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                      )}
                                    </Row>
                                  </>
                                )}
                                <Row>
                                  <Col sm="12">
                                    <div className="form-check mb-3">
                                      <SafeField
                                        className="form-check-input"
                                        type="checkbox"
                                        name="updateViaEmail"
                                        id="updateViaEmail"
                                      />
                                      {" "} <label htmlFor="updateViaEmail" className="form-check-label">Provide update via email</label>
                                    </div>
                                  </Col>
                                  {values.updateViaEmail && (
                                    <Col md="12">
                                      <JoditEditor
                                        value={values.emailContent}
                                        onBlur={(newContent) => {
                                          setFieldValue('emailContent', newContent);
                                        }}
                                        config={{
                                          readonly: false,
                                          placeholder: "Start typing here...",
                                          height: 400,

                                        }}
                                      />
                                    </Col>
                                  )}
                                </Row>
                                <Row id="noteRow">
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="unitNote">
                                        {this.props.t("Add Note")}
                                      </Label>
                                      <SafeField
                                        name="unitNote"
                                        onChange={handleChange}
                                        as="textarea"
                                        className={
                                          "form-control" +
                                          (errors.unitNote && touched.unitNote
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="unitNote"
                                      />
                                      <ErrorMessage
                                        name="unitNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                            <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>
                          </Form>
                        )}
                      </Formik>


                    </div>
                  </TabPane>
                </TabPane>
              </TabContent>



            </OffcanvasBody>
          </Offcanvas>
          <Offcanvas
            isOpen={this.state.isDocView}
            direction="end"
            toggle={this.toggleViewDocument}

          >
            <OffcanvasHeader toggle={this.toggleViewDocument}>
              View Documents
            </OffcanvasHeader>
            <OffcanvasBody>

              <div className="table-responsive">

                <Table className="table table-sm m-0">

                  <tbody>
                    {map(worksheetDocData, (docData, dockey) => (
                      <tr>
                        <th scope="row">{dockey + 1}</th>
                        <td>{docData.documentTitle}</td>
                        <td><a target="_blank" rel="noreferrer" href={docData.documentURL}>View</a></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <p>{" "}</p>



              </div>


            </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
            isOpen={this.state.isUnitView}
            direction="end"
            toggle={this.toggleUnitInformation}

          >
            <OffcanvasHeader toggle={this.toggleUnitInformation}>
              View Units
            </OffcanvasHeader>
            <OffcanvasBody>


              <Table className="table table-sm m-0">

                <tbody>
                  {map(worksheetUnitData, (unitData, unitkey) => (
                    <>
                      <tr>
                        <th scope="row">Choice {unitkey + 1}</th>
                        <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>


                      </tr>
                      <tr>
                        <td colSpan="2">Notes: {unitData.optionNotes}</td>
                      </tr>
                    </>
                  ))}


                </tbody>
              </Table>
              <div>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: worksheetLead.id,

                    unitStatusId: worksheetLead.unitStatusId,
                    unitStatusText: 'Unit Allocated',
                    unitNote: worksheetLead.unitNote,
                    projectLeadWorkSheetId: worksheetLead.projectLeadWorkSheetId,
                    allocationBy: parseInt(localStorage.getItem('userId')),

                  }}

                  onSubmit={(values) => {
                    const allocationData = {
                      id: parseInt(values.id),
                      projectLeadWorkSheetId: parseInt(values.id),
                      unitStatusId: parseInt(values.unitStatusId),
                      unitStatusText: values.unitStatusText,
                      unitNote: values.unitNote,
                      allocationBy: parseInt(values.allocationBy),
                      createProjectLeadWorkSheetAllocationList: []
                    };
                    const obj = JSON.parse(localStorage.getItem("authUser"));
                    const token = obj.resultData.bearerToken;
                    const str = 'Bearer ' + token;
                    const headers = {
                      'Content-Type': 'application/json',
                      'Authorization': str
                    };

                    toast.loading("Please wait...");
                    axios.post(`${API_URL}ProjectLeadWorkSheet/AddProjectLeadWorkSheetAllocation`, allocationData, { headers })
                      .then(response => {
                        toast.dismiss();
                        if (response.data.success) {
                          toast.success("Unit Data Submitted");
                          onGetProjectWorksheetLead(this.props.match.params.projectId, 3);
                          
                          this.unitViewToggle();
                        } else {
                          toast.warn(response.validationErrors[0]);
                        }
                      })
                      .catch(error => {
                        toast.dismiss();
                        console.error('Error:', error);
                      });
                  }}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">


                            <Input
                              type="radio"
                              id="customRadioInline3"
                              name="unitStatusId"
                              className="form-check-input mt-2"
                              value="3"
                              checked={values.unitStatusId === 3}
                              onChange={(e) => {
                                setFieldValue('unitStatusId', 3);
                                setFieldValue('unitStatusText', 'Unit Allocated');
                              }}
                            />
                            <Label
                              className="form-check-label ms-4"
                              htmlFor="customRadioInline3"
                            >
                              <span className="">Unit Allocated</span>
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Input
                              type="radio"
                              id="customRadioInline4"
                              name="unitStatusId"
                              className="form-check-input mt-2"
                              value="4"
                              checked={values.unitStatusId === 4}
                              onChange={(e) => {
                                setFieldValue('unitStatusId', 4);
                                setFieldValue('unitStatusText', 'Withdrawn from client');
                              }}
                            />
                            <Label
                              className="form-check-label ms-4"
                              htmlFor="customRadioInline4"
                            >
                              Withdrawn from client
                            </Label>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row id="noteRow">
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="unitNote">
                              {this.props.t("Add Note")}
                            </Label>
                            <SafeField
                              name="unitNote"
                              onChange={handleChange}
                              as="textarea"
                              className={
                                "form-control" +
                                (errors.unitNote && touched.unitNote
                                  ? " is-invalid"
                                  : "")
                              }
                              id="unitNote"
                            />
                            <ErrorMessage
                              name="unitNote"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>
                    </Form>
                  )}
                </Formik>
              </div>


            </OffcanvasBody>
          </Offcanvas>

        </div>
        <Modal size="lg" isOpen={this.state.showModal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            Print Preview
          </ModalHeader>
          <ModalBody>
            <Button color="primary float-end" onClick={this.handlePrint}>Print</Button>{' '}
            <div id="print-content">
              {map(worksheetPurData, (purData, purkey) => (
                <>
                  <h4>Purchaser Detail</h4>
                  <h5>Purchaser {purkey + 1}</h5>
                  <div className="table-responsive">
                    <Table className="table table-sm m-0">

                      <tbody>
                        <tr>
                          <th scope="row">Name</th>
                          <td>{purData.firstName + " " + purData.lastName}</td>

                        </tr>
                        <tr>
                          <th scope="row">Address</th>
                          <td>{purData.address}</td>
                        </tr>
                        <tr>
                          <th scope="row">City</th>
                          <td>{purData.city}</td>

                        </tr>
                        <tr>
                          <th scope="row">Province</th>
                          <td>{purData.province}</td>

                        </tr>
                        <tr>
                          <th scope="row">Phone</th>
                          <td>{purData.homePhone}</td>

                        </tr>
                        <tr>
                          <th scope="row">Cell</th>
                          <td>{purData.cellPhone}</td>
                        </tr>
                        <tr>
                          <th scope="row">Email</th>
                          <td>{purData.email}</td>

                        </tr>
                        <tr>
                          <th scope="row">Birth Date</th>
                          <td>{purData.birthDate ? <Moment format="D MMM YY">{purData.birthDate}</Moment> : ''}</td>
                        </tr>
                        <tr>
                          <th scope="row">Drivers License</th>
                          <td>{purData.driversLicense}</td>

                        </tr>
                        <tr>
                          <th scope="row">Occupation</th>
                          <td>{purData.occupation}</td>
                        </tr>

                      </tbody>
                    </Table>
                  </div>
                  <h4>Unit Choices Detail</h4>
                  <div className="table-responsive">
                    <Table className="table table-sm m-0">

                      <tbody>

                        {map(worksheetUnitData, (unitData, unitkey) => (
                          <>
                            <tr>
                              <th scope="row">Choice {unitkey + 1}</th>
                              <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>


                            </tr>
                            <tr>
                              <td colSpan="2">Notes: {unitData.optionNotes}</td>
                            </tr>
                          </>
                        ))}


                      </tbody>
                    </Table>
                  </div>
                  <p>{" "}</p>
                  <div className="table-responsive">


                    <h4>Document Detail</h4>
                    <Table className="table table-sm m-0">

                      <tbody>
                        {map(worksheetDocData, (docData, dockey) => (
                          <tr>
                            <th scope="row">{dockey + 1}</th>
                            <td>{docData.documentTitle}</td>

                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                </>
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handlePrint}>Print</Button>{' '}
            <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

projectClient.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  className: PropTypes.any,
  worksheetLeads: PropTypes.array,
  onGetProjectWorksheetLead: PropTypes.func,
  onGetProjectWorksheetLeadDocDetail: PropTypes.func,
  onGetProjectWorksheetLeadUnitDetail: PropTypes.func,
  onGetProjectWorksheetLeadPurDetail: PropTypes.func,
  worksheetUnitData: PropTypes.array,
  worksheetDocData: PropTypes.array,
  onGetProjectWorksheetUnitinfo: PropTypes.func,
  unitdata: PropTypes.object,
  worksheetPurData: PropTypes.array,

  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  notes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  followups: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  leadFollows: PropTypes.array,
  isResponsive: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object

}
const mapStateToProps = ({ Project, projectleads }) => (
  {
    projectData: Project.projectData,
    loading: Project.loading,
    worksheetLeads: Project.worksheetLeads,
    worksheetUnitData: Project.worksheetUnitData,
    worksheetPurData: Project.worksheetPurData,
    worksheetDocData: Project.worksheetDocData,
    unitdata: Project.unitdata,
    activities: projectleads.activities,
    unitdata: Project.unitdata,
    activities: projectleads.activities,
    followups: projectleads.followups,
    notes: projectleads.notes,
    calllogs: projectleads.calllogs,
    emaillogs: projectleads.emaillogs,
    leadFollows: projectleads.leadFollows
  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  onGetProjectWorksheetLead: (projectId, statusId) => dispatch(getProjectWorksheetLead(projectId, statusId)),
  onGetProjectWorksheetLeadUnitDetail: (id) => dispatch(getProjectWorksheetLeadUnitDetail(id)),
  onGetProjectWorksheetLeadDocDetail: (id) => dispatch(getProjectWorksheetLeadDocDetail(id)),
  onGetProjectWorksheetUnitinfo: (id) => dispatch(getProjectWorksheetUnitinfo(id)),
  onGetProjectWorksheetLeadPurDetail: (id) => dispatch(getProjectWorksheetLeadPurDetail(id)),


  onAddLeadFollowUp: (data) => dispatch(addActivityProjectFollowUp(data)),
  onGetAllActLead: (leadId, projectGuid) => dispatch(getProjectLeadAct(leadId, projectGuid)),
  onGetFollowLead: (leadId, projectGuid) => dispatch(getActivityProjectFollowUp(leadId, projectGuid)),
  onAddLeadNote: (data) => dispatch(addProjectLeadNote(data)),
  onGetNoteLead: (leadId, projectGuid) => dispatch(getProjectLeadNote(leadId, projectGuid)),
  onAddCallLog: (data) => dispatch(addProjectLeadCallLog(data)),
  onGetLeadCallLog: (leadId, projectGuid) => dispatch(getProjectLeadCallLog(leadId, projectGuid)),
  onAddEmailLog: (data) => dispatch(addProjectLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId, projectGuid) => dispatch(getProjectLeadEmailLog(leadId, projectGuid)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectClient)))
